import axios from "axios";
import CryptoJS from "crypto-js";
import { handleLogout } from "./getRequest";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

const decryptFunction = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

const detailsPageDataAPI = process.env.REACT_APP_GET_DETAILS_API;

/**
 * The stored transcript for one call, plus the redaction mapping needed to
 * display it: { callId, transcript, mapping }.
 *
 * Served by the details-insight endpoint rather than folded into the member
 * payload — that response repeats one row per prompt, and a transcript column
 * would ride along dozens of times per call. Fetched lazily, only when the
 * expanded audio player opens.
 */
export const getCallTranscript = async (callId) => {
  const authToken = localStorage.getItem("authToken");
  const url = `${detailsPageDataAPI}&transcriptFor=${encodeURIComponent(callId)}`;

  let response;
  try {
    response = await axios.get(url, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      handleLogout();
      return { callId, transcript: "", mapping: "" };
    }
    throw error;
  }
  return decryptFunction(response.data);
};
